module.exports = __webpack_public_path__ + "static/img/card_2_11.93089ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/card_2_11.png
// module id = 0AO7
// module chunks = 0